module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_7005.a6ebb7ed.png";